import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import FotoPacks from "../components/fotografia/FotoPacks";
import { etiquetaPrecio, formatCLP } from "../data/precios";
import { SEGMENTOS_PRECIOS, desdeIvaIncluido, precioDesde } from "../data/segmentos";
import { PAGES, breadcrumbJsonLd } from "../seo/config";

const crumbs = [
  { name: "Inicio", path: "/" },
  { name: "Precios", path: "/precios" },
];

const PreciosPage = () => (
  <>
    <Seo
      title={PAGES.precios.title}
      description={PAGES.precios.description}
      keywords={PAGES.precios.keywords}
      path={PAGES.precios.path}
      jsonLd={[breadcrumbJsonLd(crumbs)]}
    />

    <section className="bg-sand-50 pb-10 pt-28 md:pt-32">
      <div className="container-page">
        <h1 className="font-display text-display-md font-bold text-navy-900">
          ¿Cuánto cuesta un fotógrafo para tu evento?
        </h1>
        <ul className="mt-8 flex flex-wrap gap-2">
          {SEGMENTOS_PRECIOS.map((segmento) => (
            <li key={segmento.id}>
              <a href={`#${segmento.id}`} className="btn-ghost !px-5 !py-2.5 !text-sm">
                {segmento.nombreCorto}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>

    {/* Un bloque de packs por servicio, con su ancla. El fondo alterna para
        que tres bloques seguidos no se lean como una sola lista larga. */}
    {SEGMENTOS_PRECIOS.map((segmento, i) => (
      <FotoPacks
        key={segmento.id}
        segmento={segmento}
        id={segmento.id}
        titulo={segmento.nombre}
        alcance={false}
        className={`${i % 2 ? "bg-white" : "bg-sand-50"} scroll-mt-24 py-16 md:py-20`}
      />
    ))}

    {/*
      La comparativa. Pone en una sola tabla lo que el mercado cobra — con
      fuente — y lo que cobra Omega. Solo entran los servicios con dato de
      mercado publicado: sin fuente, la fila sería una afirmación.
    */}
    <section className="bg-sand-100 py-16">
      <div className="container-page">
        <h2 className="section-title max-w-2xl">Lo que cobra el mercado chileno, al lado.</h2>
        <div className="mt-10 overflow-x-auto">
          <table className="w-full min-w-[36rem] text-left text-sm">
            <thead>
              <tr className="border-b border-navy-300">
                <th className="py-3 pr-4 font-semibold text-navy-900">Qué se fotografía</th>
                <th className="py-3 pr-4 font-semibold text-navy-900">Mercado</th>
                <th className="py-3 pr-4 text-right font-semibold text-navy-900">Omega, desde</th>
                <th className="py-3 font-semibold text-navy-900">Fuente</th>
              </tr>
            </thead>
            <tbody>
              {SEGMENTOS_PRECIOS.filter((segmento) => segmento.mercado).map((segmento) => (
                <tr key={segmento.id} className="border-b border-navy-200 align-top">
                  <th className="py-4 pr-4 font-medium text-navy-900">
                    <Link to={segmento.path} className="underline decoration-sand-400 underline-offset-4">
                      {segmento.nombre}
                    </Link>
                  </th>
                  <td className="py-4 pr-4 tabular-nums text-navy-700">
                    {formatCLP(segmento.mercado.low)} – {formatCLP(segmento.mercado.high)} por{" "}
                    {segmento.mercado.unidad}
                  </td>
                  <td className="py-4 pr-4 text-right font-semibold tabular-nums text-navy-900">
                    {etiquetaPrecio(precioDesde(segmento), {
                      ivaIncluido: desdeIvaIncluido(segmento),
                    })}
                  </td>
                  <td className="py-4 text-xs text-navy-500">{segmento.mercado.fuente}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </>
);

export default PreciosPage;
